<template>
<v-main  v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :page_title="page_title" :onTop="onTop" v-on:editContent="editContent"></header-common>
  <v-container fluid class="mb-5" style="background: url('https://demo.artureanec.com/html/transx/img/contacts-map.png') no-repeat center; margin-top:75px;">
    <v-container class="text-left">
        <v-row>
            <v-col cols="12" md="6">
                <h3>Office Rades</h3>
                <v-list class="contact-list" style="background:transparent;">
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-phone-outline</v-icon></v-btn>
                        <div class="ml-5">
                            <span>+216 71 461 710</span><br/>
                            <span>+216 71 461 713</span>
                        </div>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-email-outline</v-icon></v-btn>
                        <div class="ml-5">
                            <span>manager@primeshipping.tn</span><br/>
                            <span>manager@prime-shipping-agency.com</span>
                        </div>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-map-marker-outline</v-icon></v-btn>
                        <div class="ml-5">
                            <span @click="editContent('page.contact.rades_address')">{{ $vuetify.lang.t('$vuetify.page.contact.rades_address') }}<!--App N°2, 3 Rue Habib Thameur, Rades--></span>
                        </div>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-share-variant-outline</v-icon></v-btn>
                        <div class="ml-5 social">
                            <v-btn icon><v-icon>mdi-facebook</v-icon></v-btn>
                            <v-btn icon><v-icon>mdi-linkedin</v-icon></v-btn>
                            <v-btn icon><v-icon>mdi-twitter</v-icon></v-btn>
                        </div>
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col cols="12" md="6">
                <h3>Office Bizerte</h3>
                <v-list class="contact-list" style="background:transparent;">
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-phone-outline</v-icon></v-btn>
                        <div class="ml-5">
                            <span>+216 71 461 710</span><br/>
                            <span>+216 71 461 713</span>
                        </div>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-email-outline</v-icon></v-btn>
                        <div class="ml-5">
                            <span>manager@primeshipping.tn</span><br/>
                            <span>manager@prime-shipping-agency.com</span>
                        </div>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-map-marker-outline</v-icon></v-btn>
                        <div class="ml-5">
                            <span>App N°2, 3 Rue Habib Thameur, Rades</span>
                        </div>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-btn fab outlined large><v-icon>mdi-share-variant-outline</v-icon></v-btn>
                        <div class="ml-5 social">
                            <v-btn icon><v-icon>mdi-facebook</v-icon></v-btn>
                            <v-btn icon><v-icon>mdi-linkedin</v-icon></v-btn>
                            <v-btn icon><v-icon>mdi-twitter</v-icon></v-btn>
                        </div>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
  </v-container>
  <HereMap  :center="center" />
  <v-container style="margin-top: -170px;position: relative;background: white;">
    <v-row>
            <v-col cols="12" md="6" style="margin:0 auto;">
                <h3>Envoyer un message..</h3>
                <v-row>
                    <v-col md="6">
                        <v-text-field
                        v-model="label"
                        label="Nom"
                        hide-details
                        class="rounded-0"
                        outlined
                        ></v-text-field>
                    </v-col>
                    <v-col md="6">
                        <v-text-field
                        v-model="label"
                        label="Email"
                        class="rounded-0"
                        hide-details
                        outlined
                        ></v-text-field>
                    </v-col>
                    <v-col md="6">
                        <v-text-field
                        v-model="label"
                        label="Phone"
                        class="rounded-0"
                        outlined
                        hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col md="6">
                        <v-text-field
                        v-model="label"
                        label="Object"
                        class="rounded-0"
                        outlined
                        hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col md="12">
                        <v-textarea
                        name="input-7-1"
                        outlined
                        hide-details
                        class="rounded-0"
                        label="Message"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
  </v-container>
  <footer-prime v-on:editContent="editContent"></footer-prime>
</v-main>
</template>

<script>
import headerCommon from "./commons/header"
import footerPrime from "./commons/footer"
import logo_light from "../../assets/logo_light.png"
import logo_dark from "../../assets/logo_dark.png"
import aboutImg from "../../assets/section_1.jpg"
import aboutCart from "../../assets/about_cart.png"
import HereMap from './commons/HereMap.vue'

export default {
  name: 'contact',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      gerbable: false,
      page_title: 'contact',
      backgroundUrl: logo_light,
      aboutImage: aboutImg,
      onTop: true,
      aboutCart: aboutCart,
      center:  {lat:"36.767330845833385", lng:"10.272675735582022"},
      label: '',
      team: [
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_1.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_2.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_3.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_4.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_5.jpg'},
        {name: 'Lorem Ipsum', profile_picture: 'https://demo.artureanec.com/html/transx/img/team_6.jpg'}
      ]
    }),
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'Contact'})
      }
    },
    components: {
      headerCommon, 
      footerPrime,
      HereMap
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.contact-list .v-list-item .v-btn{
    color: #465d7d;
}
.contact-list .v-list-item span {
    font-weight: 400;
    letter-spacing: 1.2px;
}
.social .v-btn{
    color:#414a53 !important;
}
.social .v-btn:hover{
    color:#1976d2 !important;
}
.social .v-btn:hover:before{
    opacity:0;
}
.contact-list .v-list-item{
    margin-top: 20px;
    color: gray;
}
*{
  transition: all .3s ease-in;

}
.team-description {
    position: absolute;
    background: #003d90;
    bottom: 5px;
    padding:15px;
    left:1px;
    color: white;
    overflow: hidden;
    width:85%;
    height:75px;
    clip-path: polygon(90% 0,100% 15%,100% 100%,0 100%,0 0);
    text-align:left;
}
.team-member .member-name {
  font-weight:700;
  margin-bottom: 0px;
  letter-spacing:1.2px;
}
.team-member {
  bottom:0px;
}
.team-member:hover {
  bottom:5px;
}
.team-member .member-position, .team-member .v-btn {
    color: #427ccb;
    font-size: 14px;
    font-weight: 700;
}
.team-member:hover .team-description{
  height:120px;
}
.list-about .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
  color: rgb(65, 74, 82) !important;
  line-height:25px;
  padding-bottom: 15px;
}
.image-badge{
  width:340px;
  min-height: 100px;
  position: relative;
  background: #003d90 url('https://demo.artureanec.com/html/transx/img/badge-img.png') no-repeat bottom right;
  background-size:contain;
  color: white;
  padding:15px 10px;
  bottom: 65px;
  left: 180px;
  font-weight:700;
  clip-path: polygon(90% 0,100% 16%,100% 100%,0 100%,0 0);
  font-size:32px;
  text-align: left;
  text-transform: capitalize;
}
.about-cart{
  width:100%;
  height:fit-content;
  background-size:cover;
}
.about-image{
  width:100%;
  min-height:400px;
}
* {
  font-family: 'Inter', sans-serif;
}
.footer-link:before{
  opacity: 0 !important;
}
.footer-link:hover {
  background: transparent;
  
}
.footer-link {
  color: white !important;
}
.footer-link:after {
  position: absolute;
  min-height:0px;
  height: 2px;
  left: 15px;
  right: 0;
  bottom: 0px;
  content: "";
  background: #2196f3;
  opacity:0;
  transition: all .2s ease-in-out;
  width:0;
}
.footer-link:hover:after{
  opacity: 1;
  width:35px;
  
}
.on-hover {
  background: #1976d2;
  color: white!important;
}
.on-hover-about {
  background: white;
  color: #515151!important;
}
.footer-list p {
  margin-bottom: 10px;
  color: #e8edf4;
  font-size: 14px;
  letter-spacing: 0px;
}
.footer-list p b{
  color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 20px;
  font-size: 18px;
  font-weight: 700;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/contact.vue